export default "__VITE_ASSET__Pb7wT28z__"